import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    // turbo-frame の読み込み完了時にタイトルを更新
    const frame = this.dialogTarget.querySelector("turbo-frame")
    if (frame) {
      frame.addEventListener("turbo:frame-load", () => this.updateTitle())
    }
  }

  open(event) {
    event.preventDefault()
    const url = event.currentTarget.href || event.params.url
    if (url) {
      this.loadContent(url)
    }
    this.dialogTarget.open = true
  }

  close() {
    this.dialogTarget.open = false
    this.clearContent()
  }

  loadContent(url) {
    const frame = this.dialogTarget.querySelector("turbo-frame")
    if (frame) {
      frame.src = url
    }
  }

  clearContent() {
    const frame = this.dialogTarget.querySelector("turbo-frame")
    if (frame) {
      frame.innerHTML = ""
      frame.src = ""
    }
    this.dialogTarget.label = ""
  }

  updateTitle() {
    const frame = this.dialogTarget.querySelector("turbo-frame")
    const title = frame?.dataset.modalTitle
    if (title) {
      this.dialogTarget.label = title
    }
  }

  // フォーム送信成功時にモーダルを閉じる
  submitEnd(event) {
    if (event.detail.success) {
      this.close()
    }
  }
}
